<template>
    <div id="header-products-wrapper"
         ref="headerProductsWrapper"
         class="pos-fixed w-screen h-screen pos-top"
         :class="{open: slideMobileDrawerToRight, closed: !slideMobileDrawerToRight, 'hidden-xs': hideMobileDrawer}">
        <div id="header-mobile-overlay"
             class="header-overlay"
             @click="slideMobileDrawerToRight = false"></div>
        <div id="header-products"
             class="pos-fixed h-full flex-column">
            <div class="d-flex flex-align-center py-2 text-white bg-default-3 px">
                <a href="/"
                   class="header-mobile-logo header-logo-diamond mr-auto"></a>
                <a target="_self"
                   class="desloged text-center text-underline text-white"
                   :href="$scope.REQUEST_URI && $scope.REQUEST_URI.indexOf('/entrar/?b') === 0 ? $scope.REQUEST_URI : `/entrar/${$scope.REQUEST_URI ? `?back=${$scope.REQUEST_URI.substr(1)}` : ''}`">
                    <h4 class="my-0">Entre ou cadastre-se</h4>
                </a>
                <h4 class="hidden logged my-0">
                    <a target="_self"
                       :href="`/${!$scope.CUSTOMER ? 'entrar/?back=' : ''}minha-conta/`"
                       class="text-underline text-white">
                        Minha Conta
                    </a>
                    &nbsp;|&nbsp;
                    <a class="hidden logged logout text-right text-underline text-white"
                       :href="'/logout.php' + ($scope.REQUEST_URI ? `?back=${$scope.REQUEST_URI.substr(1)}` : '')">
                        Sair
                    </a>
                </h4>
            </div>
            <!--header-items-mobile-->
            <nav
                v-for="(group, index) in items"
                class="header-drawer-items border-bottom border-dashed border-default-3">
                <template v-for="item in group.children">
                    <a
                        class="h5 my-0"
                        :href="item.url"
                        :class="{'text-bold': index === 0, 'header-collapsible-title pos-relative': !!item.children, opened: item.opened}"
                        @click="item.opened = !item.opened">
                        {{ item.title }}
                    </a>
                    <div
                        v-if="item.children"
                        class="collapsible"
                        :class="{opened: item.opened}">
                        <a
                            v-for="child in item.children"
                            class="h5 my-0"
                            :href="child.url">
                            {{ child.title }}
                        </a>
                    </div>
                </template>
            </nav>
        </div>
    </div>
</template>

<script>
    import {EventBus, lazyLoadInstance} from "../../../common/common";
    import Hammer from "hammerjs";
    import {SHOW_MOBILE_MENU_EVENT} from "../../events";

    export default {
        el: '#header-mobile-nav',

        name: "HeaderMobile",

        data() {
            this.$scope.MOBILE_MENU.forEach(i => i.children = i.children.map(c => ({...c, opened: false})))

            return {
                items: this.$scope.MOBILE_MENU,

                isMounted: false,

                slideMobileDrawerToRight: false,
                hideMobileDrawer: true,
            }
        },

        created() {
            EventBus.$on(SHOW_MOBILE_MENU_EVENT, () => this.slideMobileDrawerToRight = true);
        },

        mounted() {
            if (this.$refs.headerProductsWrapper) {
                const panHandler = (e) => {
                    if (e.isFinal && e.additionalEvent === 'panleft') {
                        this.slideMobileDrawerToRight = false;
                    }
                };

                const panRecognizer = new Hammer.Pan({
                    threshold: 0,
                    pointers: 0,
                    direction: Hammer.DIRECTION_HORIZONTAL
                });

                this.sliderManager = new Hammer.Manager(this.$refs.headerProductsWrapper);
                this.sliderManager.add(panRecognizer);
                this.sliderManager.on('pan', panHandler);
            }

            this.$nextTick(() => lazyLoadInstance.update());

            this.isMounted = true;
        },

        watch: {
            slideMobileDrawerToRight(newValue, oldValue) {
                if (newValue && !oldValue) {
                    this.hideMobileDrawer = false;
                } else if (!newValue && oldValue) {
                    setTimeout(() => this.hideMobileDrawer = true, 500);
                }
            }
        },
    }
</script>